import { cardClassName } from "@/modules/utils/dashboard/constants";
import { JobOption } from "@/modules/types/dashboard";
import { useClientTranslations } from "@/lib/translate";

type DashboardHeaderProps = {
  fromDate: string;
  toDate: string;
  selectedJobId: string;
  onFromDateChange: (value: string) => void;
  onToDateChange: (value: string) => void;
  onJobIdChange: (value: string) => void;
  jobOptions: JobOption[];
};

export const DashboardHeader = ({
  fromDate,
  toDate,
  selectedJobId,
  onFromDateChange,
  onToDateChange,
  onJobIdChange,
  jobOptions,
}: DashboardHeaderProps) => {
  const { t } = useClientTranslations("dashboard-page");

  return (
    <header
      className={`${cardClassName} flex flex-col gap-4 lg:flex-row lg:items-end`}
    >
      <div className="grow">
        <h1 className="text-xl font-semibold text-slate-900 dark:text-slate-100 md:text-2xl">
          {t("dashboard.header.title")}
        </h1>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          {t("dashboard.header.subtitle")}
        </p>
      </div>

      <div className="grid w-full gap-3 sm:grid-cols-2 lg:w-auto lg:grid-cols-3">
        <label className="flex flex-col gap-1 text-xs font-medium text-slate-500 dark:text-slate-400">
          {t("dashboard.header.fromDate")}
          <input
            type="date"
            value={fromDate}
            onChange={(event) => onFromDateChange(event.target.value)}
            className="h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 focus:ring-primary focus:border-primary"
          />
        </label>

        <label className="flex flex-col gap-1 text-xs font-medium text-slate-500 dark:text-slate-400">
          {t("dashboard.header.toDate")}
          <input
            type="date"
            value={toDate}
            onChange={(event) => onToDateChange(event.target.value)}
            className="h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 focus:ring-primary focus:border-primary"
          />
        </label>

        <label className="flex flex-col gap-1 text-xs font-medium text-slate-500 dark:text-slate-400">
          {t("dashboard.header.jobFilter")}
          <select
            value={selectedJobId}
            onChange={(event) => onJobIdChange(event.target.value)}
            className="h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 focus:ring-primary focus:border-primary"
          >
            <option value="all">{t("dashboard.header.allJobs")}</option>
            {jobOptions.map((item) => (
              <option key={item.id} value={item.id}>
                {item.title}
              </option>
            ))}
          </select>
        </label>
      </div>
    </header>
  );
};
